import SvgIcon from '@mui/material/SvgIcon';
import React from 'react';

import { petrol } from '../../../styles/mui/colors';

/**
 * @param {import('@mui/material/SvgIcon').SvgIconProps} props
 * @returns {React.JSX.Element}
 */
const IconAmenitiesShowerComponent = ({ color = petrol.main, ...rest }) => {
  return (
    <SvgIcon sx={{ color }} {...rest}>
      <svg
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="m4 4 2.5 2.5" fill="none" />
        <path d="M13.5 6.5a4.95 4.95 0 0 0-7 7" fill="none" />
        <path d="M15 5 5 15" fill="none" />
        <path d="M14 17v.01" fill="none" />
        <path d="M10 16v.01" fill="none" />
        <path d="M13 13v.01" fill="none" />
        <path d="M16 10v.01" fill="none" />
        <path d="M11 20v.01" fill="none" />
        <path d="M17 14v.01" fill="none" />
        <path d="M20 11v.01" fill="none" />
      </svg>
    </SvgIcon>
  );
};

IconAmenitiesShowerComponent.displayName = 'IconAmenitiesShower';

const IconAmenitiesShower = React.memo(IconAmenitiesShowerComponent);

export default IconAmenitiesShower;
